<template>
    <div style="padding: 23px; padding-left: 0px;" class="print">
        <div v-if="$store.state.user.role.permissions.includes('can_view_prescription')">
            <div class="filters" style="align-items: center; display: flex;">
                <SelectButton v-model="selected_view" :options="history_admin" @change="getRelevantData()" aria-labelledby="single" />
                <div class="date-search-container search-container" style="display: flex; align-items: center;">
                    <!-- <input type="date" v-if="selected_view == 'Admin History'" v-model="adminHistoryFormDate" placeholder="Date..." dateFormat="dd/mm/yy" /> -->
                    <Calendar v-if="selected_view == 'Admin History'" v-model="adminHistoryFormDate" selectionMode="range" placeholder="Date Range..." dateFormat="dd/mm/yy" />
                    <Calendar v-else v-model="date" selectionMode="range" placeholder="Cease / Stop On Range..." dateFormat="dd/mm/yy" />
                    <p class="blue-button" style="margin-left: 5px" @click="selected_view == 'Rx History' ? sortMedicationCharts() : sortAdministrations()">Update</p>
                </div>
                <div class="text-search-container search-container">
                    <Dropdown v-if="selected_view == 'Rx History'" @change="sortMedicationCharts()  " v-model="form.filters.drug" :options="drugs"
                        placeholder="Medication" style="position: relative" />
                    <Dropdown v-else @change="sortAdministrations() " v-model="adminHistoryForm.drug" :options="drugs"
                        placeholder="Medication" style="position: relative" />
                </div>
                <div v-if="selected_view == 'Rx History'" class="text-search-container search-container">
                    <Dropdown @change="sortMedicationCharts()" v-model="form.filters.route" :options="routes"
                        placeholder="Route" style="position: relative" />
                </div>
                <div v-if="selected_view == 'Rx History'" class="text-search-container search-container">
                    <Dropdown v-model="form.filters.type" :options="typeOptions" optionValue="chart_name" optionLabel="name"
                        @change="sortMedicationCharts()" placeholder="Type" style="position: relative" />
                </div>
                <button v-tooltip.bottom="'Reset Filters'" class="black-button" @click="clearFilters()">
                    Clear
                </button>
                <button v-tooltip="'Download CSV'" class="button clear-button" @click="downloadHistory()"
                    style="background-color: transparent; color: white">
                    <i class="pi pi-download" style="font-size: 1.1em !important; border-radius: 50%; padding: 8px; background-color: #0870DC; margin-top: -4px;"></i>
                </button>
                <button v-tooltip="'Print'" class="button clear-button" @click="printElem()"
                    style="margin-right: 1em; background-color: transparent; color: white" v-if="selected_view =='Admin History'">
                    <i class="pi pi-print" style="font-size: 1.1em !important; border-radius: 50%; padding: 8px; background-color: #0870DC; margin-top: -4px;"></i>
                </button>
            </div>
            <div v-if="selected_view == 'Rx History'">
                <div style="padding-top: 10px">
                    <div v-if="loading">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 2em;"></i>
                    </div>
                    <table v-else class="medication-history-table">
                        <tr>
                            <th style="width: 11em">
                                <h3 @click="sortBy('created_at', 'desc')">Created At</h3>
                                <div style="display: inline; cursor: pointer">
                                    <i class="pi pi-sort" v-if="form.sort_col =='created_at' && form.sort_direction == 'asc'" @click="sortBy('created_at', 'desc')"></i>
                                    <i class="pi pi-sort" v-else @click="sortBy('created_at', 'asc')"></i>
                                </div>
                            </th>
                            <th style="width: 8em">
                                <h3 @click="sortBy('start_date', 'desc')">Start Date    </h3>
                                <div style="display: inline; cursor: pointer">
                                    <i class="pi pi-sort" v-if="form.sort_col =='start_date' && form.sort_direction == 'asc'" @click="sortBy('start_date', 'desc')"></i>
                                    <i class="pi pi-sort" v-else @click="sortBy('start_date', 'asc')"></i>
                                </div>
                            </th>
                            <th style="width: 8em">
                                <h3 @click="sortBy('stop_date', 'desc')">Stop Date</h3>
                                <div style="display: inline; cursor: pointer">
                                    <i class="pi pi-sort" v-if="form.sort_col =='stop_date' && form.sort_direction =='asc'" @click="sortBy('stop_date', 'desc')"></i>
                                    <i class="pi pi-sort" v-else @click="sortBy('stop_date', 'asc')"></i>
                                </div>
                            </th>
                            <th>Type</th>
                            <th>Medication</th>
                            <th>Status</th>
                            <th>Frequency</th>
                            <th>Route</th>
                            <th>Prescriber</th>
                            <th></th>
                            <th>Cancellation Details</th>
                        </tr>
                        <!-- @click="displayExpiredChartModal = true; displayChart = item" -->
                        <tr v-for="(item, index) in charts" :key="index" >
                            <td>{{ item.created_at }}</td>
                            <td>{{ item.start_date.slice(0,-7) }}</td>
                            <td>{{ item.stop_date.slice(0,-7) }}</td>
                            <td>
                                <div v-tooltip.left="item.chart_name" style="height: 20px; width: 20px; border-radius: 3px;"
                                    :style="{ backgroundColor: item.color + ' !important' }"></div>
                            </td>
                            <td>{{ item.alias.name }} <span style="font-weight: bold">x {{ item.dose }} {{item.dose_unit}}</span></td>
                            <td>
                                <span v-if="item.is_queued" class="orange-tag" style="margin-right: 5px; background-color: #EF9600; color: white;">Queued</span>
                                <span style="margin-right: 5px" v-else-if="!isMedicationExpired(item) && item.script_status == 'active'" class="green-tag">Active</span>
                                <span style="margin-right: 5px" v-else-if="isMedicationExpired(item)" class="orange-tag">Expired at {{ item.stop_date }}</span>
                                <span style="margin-right: 5px" v-else-if="item.script_status == 'ceased'" class="s8-tag">Ceased at {{ item.deleted_at }}</span>
                            </td>
                            <td>{{ item.frequency_shorthand }}</td>
                            <td>{{ item.route }}</td>
                            <td>{{ item.signatures.length ? item.signatures[0].person : '' }}</td>
                            <td><p v-if="$store.state.user.type === 'prescriber' && item.script_status != 'active'" class="green-button" style="margin-right: 10px;" @click="mappingChart(item), setChartType(item)">Renew</p></td>
                            <td><p class="blue-button" v-if="item.cancellation_reason || item.cancellation_signature"
                                style="padding: 5px 0px;
                                    width: fit-content;
                                    display: flex;
                                    align-items: center;" @click="openCancellationDetails(item)" ><i class="pi pi-align-justify" ></i></p></td>
                        </tr>
                    </table>
                </div>
                <div class="pagination-links">
                    <p class="pagination-arrow" v-show="pages.current_page > 1" @click="displayPage(form.page - 1)"> &larr; </p>
                    <p>Page {{ pages.current_page }} of {{ pages.page_count }}</p>
                    <p class="pagination-arrow" v-show="pages.current_page < pages.page_count"
                        @click="displayPage(pages.current_page + 1)"> &rarr; </p>
                </div>
            </div>
            <div v-if="selected_view =='Admin History'" class="print">
                <div style="padding-top: 10px">
                    <div v-if="loading">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;margin-top: 2em;"></i>
                    </div>
                    <div v-else>
                        <div v-if="!administrations.length">
                            <h3>No administrations found.</h3>
                        </div>
                        <table v-else class="medication-history-table">
                            <tr>
                                <th>Date & Time</th>
                                <th>Type</th>
                                <th>Drug</th>
                                <th>Quantity</th>
                                <th>Administered</th>
                                <th>DOC</th>
                                <th>Administrator</th>
                                <th>Notes</th>
                            </tr>
                            <tr v-for="(item, index) in administrations" :key="index" :style="!item.quantity ? {backgroundColor: 'rgba(224, 79, 57, 0.2)'} : {}">
                                <td>{{ item.administered_at}}</td>
                                <td>
                                    <div v-tooltip.left="item.chart_name" style="height: 20px; width: 20px; border-radius: 3px;"
                                        :style="{ backgroundColor: item.color + ' !important' }"></div>
                                </td>
                                <td><span class="red-tag" v-if="!item.quantity">EXPIRED MED</span> {{ item.drug.name }}</td>
                                <td>{{ item.quantity ? item.quantity : '-' }}</td>
                                <td>{{item.quantity ? (!item.doc && item.administrator ? 'Y' : 'N') : '-'}} 
                                    <span v-tooltip.bottom="`This administration event was reverted on ${item.deleted_at}`" class="red-tag" v-if="item.deleted_at">
                                        (Reverted {{ item.deleted_at }})
                                        <i style="padding: 0px;" class="pi pi-question-circle"></i>
                                    </span>
                                </td>
                                <td>{{ item.doc ? item.doc : '-' }}</td>
                                <td>{{item.administrator && item.administrator.personal_information && item.administrator.personal_information.first_name ? item.administrator.personal_information.first_name : ''}} 
                                    {{item.administrator && item.administrator.personal_information && item.administrator.personal_information.last_name ? item.administrator.personal_information.last_name : ''}}</td>
                                <td><p class="blue-button" v-if="item.note" 
                                style="padding: 5px 0px;
                                    width: fit-content;
                                    display: flex;
                                    align-items: center;" @click="modalNotes = item.note, additionalNotes=item.additional_notes, displayNotesModal = true" ><i class="pi pi-align-justify" ></i></p></td>
                            </tr>
                        </table>
                    </div>
                    
                </div>
                <div class="pagination-links" v-if="administrations.length && !this.loading">
                    <p class="pagination-arrow" v-show="pages.current_page > 1" @click="displayAdminPage(adminHistoryForm.page - 1)"> &larr; </p>
                    <p>Page {{ pages.current_page }} of {{ pages.page_count }}</p>
                    <p class="pagination-arrow" v-show="pages.current_page < pages.page_count"
                        @click="displayAdminPage(pages.current_page + 1)"> &rarr; </p>
                </div>
            </div>
            <PrescriptionRenewModal :renewScript="true" :hideClientPanel="true" v-if="displayPrescriptionRenewModal" :renewingCancelledScript="true" @close="close" :prescription="mappedPrescription" @successfullySubmitted="successfullySubmitted" />
            <ExpiredChartModal :chart="displayChart" v-if="displayExpiredChartModal" @close="close" :frequencyOptions="frequencyOptions" />
            <AdminHistoryNotesModal v-if="displayNotesModal" :notes="modalNotes" :additionalNotes="additionalNotes" @close="close" />
        </div>
        <div v-else style="margin-top: 10em;">
            <h3 style="border: 2px solid black; border-bottom: 2px solid black; width: fit-content; margin: 0 auto; padding: 5px; border-radius: 4px">
                You do not have permission to access this feature. Please talk to your admin if you require access.
            </h3>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ExpiredChartModal from '@/components/modals/ExpiredChartModal.vue';
import AdminHistoryNotesModal from '@/components/modals/AdminHistoryNotesModal.vue';
import PrescriptionRenewModal from '@/components/modals/PrescriptionRenewModal.vue';
import { isBeforeToday } from '@/services/dates';
import { isTokenExpired } from '@/utils/errors';
import { withLocalFrequencyOptions } from '@/services/frequencies';

export default {
    props: ['patient'],
    components: {
        ExpiredChartModal,
        AdminHistoryNotesModal,
        PrescriptionRenewModal
    },
    computed: {
        isChartExpired() {
            return isBeforeToday(this.patient?.erx_chart?.end_date);
        }
    },
    data() {
        return {
            displayPrescriptionRenewModal: false,
            mappedPrescription: null,
            displayNotesModal: false,
            modalNotes: '',
            additionalNotes: null,
            selected_view:'Admin History',
            history_admin:[
                'Admin History',
                'Rx History',
            ],
            displayExpiredChartModal: false,
            // The prescribing form's frequency templates. Previously handed down from
            // PatientGeneral, which passed its `frequencies` filter list - an array of frequency
            // strings scraped off the charts, not the frequency objects the form matches on.
            frequencyOptions: [],
            displayChart: '',
            loading: false,
            typeOptions: [],
            charts: [],
            drugs: [],
            frequencies: [],
            types: [],
            routes: [],
            date: [],
            adminHistoryFormDate:[],
            administrations:[],
            pages: {
                current_page: 1,
                page_count: 1,
            },
            form: {
                sort_direction: 'desc',
                sort_col: 'created_at',
                page: 1,
                filters: {
                    drug: '',
                    type: '',
                    route: '',
                    date: {
                        start: '',
                        end: ''
                    }
                },
                /**
                 * Sending deleted administration events to rx history is redundant
                 * as they don't show up in the table anyway
                 */
                include_deleted: false
            },
            adminHistoryForm:{
                drug:'',
                date:{
                    start:'',
                    end:''
                },
                page:1
            }

        }
    },
    methods: {
        openCancellationDetails(item) {
            let notes = item.cancellation_reason ? `Reason: ${item.cancellation_reason}` : '';
            const signer = (signature, label) => {
                if (!signature || !signature.uuid) return '';
                const name = signature.person || signature.user_name || 'Unknown';
                return `${label}: ${name}${signature.created_at ? ` on ${signature.created_at}` : ''}`;
            };
            const primary = signer(item.cancellation_signature, 'Signed by');
            const witness = signer(item.cancellation_witness_signature, 'Witnessed by');
            [primary, witness].forEach((line) => {
                if (line) {
                    notes = notes ? `${notes}\n${line}` : line;
                }
            });
            this.modalNotes = notes;
            this.additionalNotes = null;
            this.displayNotesModal = true;
        },
        isMedicationExpired(item) {
            if (item.script_status === 'ceased' || item.script_status === 'cancelled') {
                return false;
            }
            if (this.isChartExpired) {
                return true;
            }
            if (item.script_status === 'expired') {
                return true;
            }
            if (item.stop_date) {
                return isBeforeToday(item.stop_date);
            }
            return false;
        },
        sortBy(col, dir){
            console.log("sort col", this.form)

            this.form.sort_col = col;
            this.form.sort_direction = dir;

            this.getRelevantData();
        },
        close(value) {
            if (value) {
                this.displayExpiredChartModal = false;
                console.log('expired chart should be closed');
                this.displayNotesModal = false;
                this.displayPrescriptionRenewModal = false;
            }
        },
        getFrequencies() {
            const facilityId = this.patient?.physical_location?.location?.facility?.uuid;
            if (!facilityId) return;
            this.$store.dispatch('getRefreshToken');
            axios.post('/prescription/frequencies', { facility_id: facilityId }, this.$store.state.header).then(res => {
                this.frequencyOptions = withLocalFrequencyOptions(res.data);
            }).catch(err => {
                console.log('frequency list failed', err);
            })
        },
        mappingChart(value){
            console.log('mapping chart', value, this.patient);
            
            let formatted_dose_times = value.dose_times;
            if (formatted_dose_times && formatted_dose_times.length > 0 && !formatted_dose_times[0].times && formatted_dose_times[0].time) {
                formatted_dose_times = [{
                    day: null,
                    date: null,
                    times: value.dose_times.map(dt => ({ time: dt.time, qty: dt.qty, uuid: dt.uuid }))
                }];
            }

            value.activePresChart = {
                chart_payload: {
                    prescription_id: value.uuid,
                    script_status: value.script_status,
                    chart_form: {
                        type: value.chart_type,
                        route: value.route,
                        indication: value.indication,
                        tags: []
                    }
                },
                prescription_payload: {
                    scheduled: value.alias.tags.includes('S8') ? true : false,
                    patient_id: this.patient.uuid,
                    patient: this.patient,
                    prescriber: value.doctor?.uuid ? value.doctor?.uuid : '',
                    drug_uuid: value.alias.alias_id,
                    substitution_not_permitted: value.substitution_not_permitted ? true : false,
                    chart_id: value.chart_id,
                    authority_prescription_number: value.authority_prescription_number ? value.authority_prescription_number  : '',
                    pbs_code: value.pbs_code ? value.pbs_code  : '',
                    pbs_manufacturer_code: value.pbs_manufacturer_code ? value.pbs_manufacturer_code  : '',
                    pbs_authority_code: value.pbs_authority_code ? value.pbs_authority_code  : '',
                    days_of_week: value.days_of_week,
                    interval: value.interval,
                    num_repeats_authorised: value.num_repeats_authorised,
                    repeat_interval: value.repeat_interval,
                    frequency: value.frequency,
                    frequency_shorthand: value.frequency_shorthand,
                    times: value.times,
                    dose: value.dose,
                    dose_unit: value.dose_unit,
                    route: value.route,
                    sliding_scale: value.sliding_scale,
                    max_admin_dose: value.max_admin_dose,
                    max_daily_admin: value.max_daily_admin,
                    is_paper: value.is_paper ? true : false,
                    paper_prescription_number : value.paper_prescription_number ? value.paper_prescription_number : value.is_paper ? '1' : '',
                    reason: value.reason,
                    max_dose: value.max_dose,
                    start_date: new Date(value.start_date).toLocaleDateString('en-AU'),
                    stop_date: new Date(value.stop_date).toLocaleDateString('en-AU'),
                    additional_regulatory_checks: '',
                    administrations: value.administrations,
                    // created_date: !isNaN(Date.parse(value.created_at)) ? new Date(value.created_at).toLocaleDateString('en-AU') : '' ,
                    created_date: new Date(value.created_at).toLocaleDateString('en-AU'),
                    dose_times : formatted_dose_times,
                    last_administration: value.last_administration ? value.last_administration  :'',
                    administration_history: value.administration ? value.administration : '',
                    prescribed_quantity: value.prescribed_quantity,
                    notes: value.instructions && value.instructions.text ? value.instructions.text : '',
                    chart_tags: value.chart_tags,
                    ctg: value.ctg ? true : false,
                    is_extemp: value.is_extemp ? true : false,
                    aslr_consent: value.aslr_consent ? true : false,
                    privacy_statement: value.privacy_statement !== false,
                    consent: value.consent ? value.consent : null,
                    consent_uuid: value.consent_uuid ? value.consent_uuid : null,
                    prescribed_pack_size_id: value.prescribed_pack_size_id ? value.prescribed_pack_size_id : null,
                    prescribed_ctpp_id: value.prescribed_ctpp_id ? value.prescribed_ctpp_id : null,
                    pack_size: value.pack_size ? value.pack_size : null,
                    signed: true,
                    erx_status: value.erx_status,
                    erx_ceased: value.erx_ceased,
                    erx_cancelled: value.erx_cancelled,
                    dismissed: value.is_dismissed
                }
            };
            value.patient = this.patient;
            console.log('mapped chart', value);
            this.mappedPrescription = value;
            this.displayPrescriptionRenewModal = true;
        },
        setChartType(value){
            let chartTypes = this.$store.getters.getChartTypes;
            chartTypes.forEach(chartType => {
                if ((value.chart_type == chartType.chart_name) || (value.chart_type == chartType.name)) {
                    console.log('LOOPING THROUGH THE CHART ITEMS', value.chart_type, chartType.chart_name);
                    value.chart_type = chartType.chart_name;
                    value.type = chartType.chart_name;
                    value.color = chartType.color;
                    value.chart_name = chartType.name;
                    value.selectedChart = chartType;
                    console.log('this is the color now', value.color);
                }
            })
        },
        loadingButtonToggle(classname){
            var button = document.querySelector('.' + classname);
            button.classList.toggle('pi-spin');
            button.classList.toggle('pi-spinner');
        },
        b64toBlob(b64Data, contentType = '', sliceSize = 512){
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize),
                    byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
        printElem() {
            this.$store.dispatch('getRefreshToken');

            this.loadingButtonToggle('pi-print');

            let filename = this.patient?.personal_information?.first_name && this.patient?.personal_information?.last_name ? this.patient.personal_information.first_name + this.patient.personal_information.last_name : this.$resident({ capitalize: true });

            // Open new window immediately to bypass popup blockers
            let newWindow = window.open('', 'PRINT', 'height=600,width=1000');
            if (newWindow) {
                newWindow.document.write('<html><body><div style="display:flex; justify-content:center; align-items:center; height:100vh; font-family:sans-serif;"><h3>Generating PDF...</h3></div></body></html>');
            }

            axios.post('/generate/admin-chart', {
                patient_id: this.patient.uuid,
                location: this.$store.state.currentLocation?.uuid,
                date_start: this.adminHistoryForm.date.start,
                date_end: this.adminHistoryForm.date.end,

            }, this.$store.state.header)
            .then(async res => {
                let res_data = res.data.body;
                if (typeof res_data === 'string') {
                    res_data = res_data.replace(/"/g, '');
                }

                // Blob URL rather than a data: URL - Chrome blocks data: URLs in
                // frames and caps them by size, so large charts never rendered.
                const blob = this.b64toBlob(res_data, "application/pdf");
                const pdfTitle = filename + "_Administration_History.pdf";
                const objectUrl = URL.createObjectURL(blob) + '#filename=' + encodeURIComponent(pdfTitle);

                if (!newWindow) {
                    console.log('print window was blocked');
                    return;
                }

                newWindow.document.title = pdfTitle;

                const iframe = newWindow.document.createElement('iframe');
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.border = '0';
                iframe.src = objectUrl;

                newWindow.document.body.innerHTML = '';
                newWindow.document.body.style.margin = '0';
                newWindow.document.body.appendChild(iframe);
            })
            .catch(err => {
                if (newWindow) {
                    newWindow.close();
                }
                if (isTokenExpired(err)) {
                    console.log('yes, it does include expired')
                    this.$router.push('/login');
                }
            })
            // Toggled in one place rather than in both handlers - the toggle flips rather
            // than sets, so a throw inside .then used to land in .catch and flip it back to
            // a spinner that never stops.
            .finally(() => {
                this.loadingButtonToggle('pi-print');
            })
        },
        // Exports whichever history is on screen. Both endpoints return every matching
        // row rather than the current page, and honour the filters shown above the table.
        downloadHistory() {
            if (this.selected_view == 'Rx History') {
                this.downloadCsv('/generate/rx-history-csv', {
                    patient_id: this.patient.uuid,
                    sort_col: this.form.sort_col,
                    sort_direction: this.form.sort_direction,
                    filters: this.form.filters,
                }, 'Prescription_History');
            } else {
                this.downloadCsv('/generate/admin-chart-csv', {
                    patient_id: this.patient.uuid,
                    location: this.$store.state.currentLocation?.uuid,
                    date_start: this.adminHistoryForm.date.start,
                    date_end: this.adminHistoryForm.date.end,
                    drug: this.adminHistoryForm.drug,
                }, 'Administration_History');
            }
        },
        downloadCsv(endpoint, payload, label) {
            this.$store.dispatch('getRefreshToken');

            this.loadingButtonToggle('pi-download');

            let filename = this.patient?.personal_information?.first_name && this.patient?.personal_information?.last_name ? this.patient.personal_information.first_name + this.patient.personal_information.last_name : this.$resident({ capitalize: true });

            axios.post(endpoint, payload, this.$store.state.header)
            .then(res => {
                // The csv writer only emits the header row when it serialises a first
                // record, so nothing matching the filters means an empty body and no file.
                // A filter that matches nothing is normal here, so say so.
                if (!res.data) {
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'Nothing to export',
                        detail: 'No records match the current filters.',
                        life: 4000,
                    });
                    return;
                }

                // Blob rather than a data:text/csv anchor - a data: URL is size
                // capped, which is the whole reason the export exists.
                const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
                const objectUrl = URL.createObjectURL(blob);

                const anchor = document.createElement('a');
                anchor.href = objectUrl;
                anchor.download = `${filename}_${label}_${new Date().toLocaleDateString('en-AU').split('/').join('')}.csv`;
                anchor.click();

                // Revoked a tick later - Safari and older Chrome cancel the download if the
                // URL goes away before the browser has started it.
                setTimeout(() => URL.revokeObjectURL(objectUrl), 100);
            })
            .catch(err => {
                if (isTokenExpired(err)) {
                    console.log('yes, it does include expired')
                    this.$router.push('/login');
                }
            })
            .finally(() => {
                this.loadingButtonToggle('pi-download');
            })
        },
        getRelevantData(){
            if(this.selected_view == 'Rx History'){
                this.retrieveMedicationHistory();
            } else{
                this.retrieveAdministrationHistory();
            }
        },
        clearFilters() {
            this.date= []
            this.form = {
                sort_direction: 'desc',
                sort_col: 'created_at',
                page: 1,
                filters: {
                    drug: '',
                    type: '',
                    route: '',
                    date: {
                        start: '',
                        end: ''
                    }
                }
            }
            this.adminHistoryFormDate= '';

            this.adminHistoryForm = {
                drug:'',
                date:{
                    start:'',
                    end:''
                },
                page:1
            }
            if(this.selected_view == 'Admin History'){
                this.retrieveAdministrationHistory();
            } else{
                this.retrieveMedicationHistory();
            }
            
        },
        displayPage(page) {
            this.$store.dispatch('getRefreshToken');
            this.form.page = page;
            this.retrieveMedicationHistory();
        },
        displayAdminPage(page) {
            this.$store.dispatch('getRefreshToken');
            this.adminHistoryForm.page = page;
            this.retrieveAdministrationHistory();
        },
        sortMedicationCharts() {
            this.$store.dispatch('getRefreshToken');
            if (this.date.length) {
                if (typeof this.date == "string") {
                    this.form.filters.date.start = this.date.split("-")[0]
                    this.form.filters.date.end = this.date.split("-")[1]
                } else {
                    
                    this.form.filters.date.start = new Date(this.date[0]).toLocaleDateString('en-AU');
                    this.form.filters.date.end = (this.date[1] == null) ? new Date(this.date[0]).toLocaleDateString('en-AU') : new Date(this.date[1]).toLocaleDateString('en-AU');
                }
            } else {
                this.form.filters.date.start = '';
                this.form.filters.date.end = '';
            }
            console.log('this is the filter', this.form.filters);
            this.retrieveMedicationHistory();
        },
        sortAdministrations() {
            this.$store.dispatch('getRefreshToken');
            if (this.adminHistoryFormDate.length) {
                if (typeof this.adminHistoryFormDate == "string") {
                    this.adminHistoryForm.date.start = this.adminHistoryFormDate.split("-")[0]
                    this.adminHistoryForm.date.end = this.adminHistoryFormDate.split("-")[1]
                } else {
                    this.adminHistoryForm.date.start = new Date(this.adminHistoryFormDate[0]).toLocaleDateString('en-AU');
                    this.adminHistoryForm.date.end = (this.adminHistoryFormDate[1] == null) ? new Date(this.adminHistoryFormDate[0]).toLocaleDateString('en-AU') : new Date(this.adminHistoryFormDate[1]).toLocaleDateString('en-AU');
                }
            } else {
                this.adminHistoryForm.date.start = '';
                this.adminHistoryForm.date.end = '';
            }
            // if (this.adminHistoryFormDate && this.adminHistoryFormDate.includes('-')) {
            //     this.adminHistoryForm.date = new Date(this.adminHistoryFormDate).toLocaleDateString('en-AU');
            // } 
            console.log('this is the filter', this.form.filters);
            this.retrieveAdministrationHistory();
        },
        retrieveAdministrationHistory(){
            this.$store.dispatch('getRefreshToken');
            this.administrations = [];
            this.loading = true;
            let payload = {
                filters: this.adminHistoryForm,
                page: this.adminHistoryForm.page,
                include_deleted: true // the deleted will be labelled as 'undone' in the Admin hx table
            }
            delete payload.filters.page;
            axios.post(`/person/${this.$route.params.id}/administrations`,payload, this.$store.state.header).then(res=>{
                console.log('this is the admin history', res.data);
                this.administrations = res.data.data;
                this.pages.current_page = res.data.header.current_page;
                this.pages.page_count = res.data.header.page_count;
                let chartTypes = this.$store.getters.getChartTypes;
                for (let i = 0; i < this.administrations.length; i++) {
                    this.drugs.push(this.administrations[i].drug.name);

                    if(this.administrations[i].prescription_type) {
                        if(this.administrations[i].prescription_type == 'nim') {
                            
                            this.administrations[i].chart_type = 'nim';
                            this.administrations[i].color = "#274188"
                            this.administrations[i].chart_name = "Nurse Initiated Meds";
                        } else {
                            chartTypes.forEach(chartType => {
                                if ((this.administrations[i].prescription_type == chartType.chart_name) || (this.administrations[i].prescription_type == chartType.name)) {
                                    this.administrations[i].chart_type = chartType.chart_name;
                                    this.administrations[i].color = chartType.color;
                                    this.administrations[i].chart_name = chartType.name;
                                }
                            })
                        }
                    }
                }
                this.getFilterValues();
                this.loading = false;
            })
        },
        retrieveMedicationHistory() {
            this.$store.dispatch('getRefreshToken');
            this.loading = true;
            axios.post(`/person/${this.$route.params.id}/get-rx-history`, this.form, this.$store.state.header).then(res => {
                
                this.charts = res.data.prescriptions;
                this.pages.current_page = res.data.header.current_page;
                this.pages.page_count = res.data.header.page_count;
                console.log('this is the patient history', res.data);

                
            }).then(() => {
                // MAPPING CHART COLOURS AND FILLING IN FILTER ARRAYS  (DUPLICATES ARE FIXED IN GET FILTER VALUES)
                console.log('GETTING MEDICATION HISTORY');
                // this.charts.forEach(chartItem=>{
                // this.drugs.push(chartItem.alias.name);
                // this.frequencies.push(chartItem.frequency);
                // this.types.push(chartItem.chart.chart_type);
                // this.routes.push(chartItem.route);

                let chartTypes = this.$store.getters.getChartTypes;
                for (let i = 0; i < this.charts.length; i++) {
                    this.drugs.push(this.charts[i].alias.name);
                    this.frequencies.push(this.charts[i].frequency);
                    this.types.push(this.charts[i].chart_type);
                    this.routes.push(this.charts[i].route);
                    chartTypes.forEach(chartType => {
                        if ((this.charts[i].chart_type == chartType.chart_name) || (this.charts[i].chart_type == chartType.name)) {
                            console.log('LOOPING THROUGH THE CHART ITEMS', this.charts[i].chart_type, chartType.chart_name);
                            this.charts[i].chart_type = chartType.chart_name;
                            this.charts[i].color = chartType.color;
                            this.charts[i].chart_name = chartType.name;
                            console.log('this is the color now', this.charts[i].color);
                        }
                    })
                    console.log('looping through this this.charts[i]', this.charts[i], this.charts.length);
                    // this.remapPresChart(this.charts[i]);
                }
                // });
                this.loading = false;
                this.getFilterValues();
            }).catch(err => {
                console.log('this is the err', err);
                if (isTokenExpired(err)) {
                    console.log('yes, it does include expired')
                    this.$router.push('/login');
                }
            })
            // setTimeout(() => {


            // }, 500);

        },
        // GETFILTERVALUES FUNCTION DROPS ALL DUPLICATES IN FILTER ARRAYS
        getFilterValues() {
            if(this.drugs.length){
                this.drugs = this.drugs.filter((v, i, a) => a.indexOf(v) === i);
            }
            if(this.routes.length){
                this.routes = this.routes.filter((v, i, a) => a.indexOf(v) === i);
            }
            if(this.types.length){
                this.types = this.types.filter((v, i, a) => a.indexOf(v) === i);
            }
            if(this.frequencies.length){
                this.frequencies = this.frequencies.filter((v, i, a) => a.indexOf(v) === i);
            }
            
            if(this.types.length){
                this.typeOptions = [];
                let chartTypes = this.$store.getters.getChartTypes;
                this.types.forEach(type => {
                    chartTypes.forEach(chartType => {
                        if (type == chartType.chart_name) {
                            this.typeOptions.push(chartType);
                            console.log('this is the list of TYPES', this.typeOptions);
                        }
                    })
                })
            }
            
        },
    },
    mounted() {
        this.retrieveAdministrationHistory();
        this.getFrequencies();
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";

 

 

  


.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}

.medication-history-table {
    margin: 0;
    padding: 5px;
    border-collapse: collapse;
    background-color: #F3F4F4;
    border-radius: 12px;

    th,
    td {
        padding: 10px 0px 10px 10px !important;
        font-size: 1em;
    }

    ;
    border-collapse: collapse;

    th {
        border-bottom: 2px solid #E7E9E8;
    }

    td {
        border-bottom: 1px solid #E7E9E8;
    }

}

@media print {
  body *:not(.printable) {
    // hide everything but printable elements and their children
    display: none;
  }
}
</style>
